// Renderiza un bloque <script type="application/ld+json"> a partir de un objeto (o arreglo de objetos) schema.org.
const JsonLd = ({ data }) => {
    if (!data) return null;

    return (
        <script
            type="application/ld+json"
            // Se escapa "<" para que un valor con "</script>" no pueda cerrar la etiqueta anticipadamente.
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
        />
    );
};

export default JsonLd;
